import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import BzmIcon from '../../icons/BzmIcon';
import styles from './PasswordInput.module.css';
import clsx from 'clsx';

interface PasswordInputProps {
  value: string;
  placeholder?: string;
  disabled?: boolean;
  id?: string;
  onChange: (value: string) => void;
  showRevealOption?: boolean;
  className?: string;
  style?: any;
}
const PasswordInput = (props: PasswordInputProps) => {
  const { placeholder } = props;
  const [showPassword, setShowPassword] = useState(false);

  //https://stackoverflow.com/questions/62391491/stop-chrome-from-autofill-email-password-on-react-test-sites
  const [readOnly, setReadOnly] = useState(true);

  return (
    <div className={'position-relative'}>
      {props.showRevealOption !== false && (
        <span className={clsx('position-absolute', styles.revealPasswordIcon)}>
          <BzmIcon
            title={showPassword ? 'Hide Password' : 'Reveal Password'}
            variant={showPassword ? 'icon-bzm-hide' : 'icon-bzm-show'}
            onClick={() => setShowPassword(!showPassword)}
          />
        </span>
      )}
      <Form.Control
        className={clsx(
          props.className ? props.className : undefined,
          styles.passwordInput,
          !showPassword && 'passwordInput',
        )}
        style={props.style ? props.style : undefined}
        id={props.id}
        autoComplete={'off'}
        disabled={props.disabled}
        readOnly={readOnly}
        onFocus={() => setReadOnly(false)}
        onBlur={() => setReadOnly(true)}
        onChange={e => props.onChange(e.target.value)}
        type={'text'}
        placeholder={placeholder ? placeholder : 'Enter Password...'}
        defaultValue={props.value}
      />
    </div>
  );
};

export default PasswordInput;
